import {JsonProperty} from '@hyperloris/tyson';
import {ApiValidation} from "./api-validation";

export class ApiFileResponse extends ApiValidation<any> {

  @JsonProperty()
  fileName: string | undefined;

  @JsonProperty()
  contentType: string | undefined;
}

